/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
// import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedEquipment: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedEquipment
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedEquipment: null })
						}} style={{ float: 'right' }}>Add New</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query query={BARANGAY_EQUIPMENT_LOOKUP} variables={{ searchFilter: filters, barangay_uid }}>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let barangayEquipmentsLookup = _.has(data,'barangayEquipmentsLookup') ? data.barangayEquipmentsLookup.data : []
								barangayEquipmentsLookup = barangayEquipmentsLookup.map((equipmentsLookup, key) => Object.assign({}, equipmentsLookup, { key }))
								let _pagination = _.has(data, 'barangayEquipmentsLookup') ? data.barangayEquipmentsLookup.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [
									{
									 	title: 'Name',
									 	dataIndex: 'name',
									 	key: 'name',
									 	//width: 300
									}, {
										title: 'Description',
										dataIndex: 'description',
										key: 'description'
									}, {
										title: 'Action',
										key: 'action',
										render: (record) => {
											return (
												<React.Fragment>
													<a href="#" onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedEquipment: record })}>Edit</a>
												</React.Fragment>
											)
										}
									}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={barangayEquipmentsLookup} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedEquipment={selectedEquipment}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedEquipment: null })}
                        />
					}
				</Col>
			</Row>
		)
	}
}

const BARANGAY_EQUIPMENT_LOOKUP = gql`
    query barangayEquipmentsLookup($barangay_uid: String, $searchFilter: SearchParams) {
		barangayEquipmentsLookup(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
